module.exports = __webpack_public_path__ + "img/lx0.8f8fb5e5.png";